<template>
  <div class="wrapper">
    <header>
      <img src="../../assets/banner1.png" alt="">
    </header>
    <div class="tab-bar ">
      <div class="tab-bar-inner clearfix">
        <div :class="[activeName=='carrier'?'active':'']" @click="activeName='carrier'" ref="carrier">承运条款</div>
        <div :class="[activeName=='compensation'?'active':'']" @click="activeName='compensation'"  ref="compensation">赔付条款</div>
        <div :class="[activeName=='embargo'?'active':'']" @click="activeName='embargo'" ref="embargo">禁运物品</div>
        <!--<div :class="[activeName=='pack'?'active':'']" @click="activeName='pack'" ref="pack">打包规则</div>-->
        <div :class="[activeName=='warehouse'?'active':'']" @click="activeName='warehouse'" ref="warehouse">网点和仓库列表</div>
        <div :class="[activeName=='tax'?'active':'']" @click="activeName='tax'" ref="tax">行邮税完税表</div>
      </div>
    </div>
    <div class="container pageService">
      <termsOfCarriage v-if="activeName=='carrier'" ></termsOfCarriage>
      <compensation v-if="activeName=='compensation'" ></compensation>
      <embargo v-if="activeName=='embargo'"></embargo>
      <pack v-if="activeName=='pack'"></pack>
      <warehouse v-if="activeName=='warehouse'"></warehouse>
      <tax v-if="activeName=='tax'"></tax>
    </div>
  </div>
</template>

<script>
   import termsOfCarriage from "./components/termsOfCarriage"
   import compensation from "./components/compensation"
   import embargo from "./components/embargo"
   import pack from "./components/pack"
   import warehouse from "./components/warehouse"
   import tax from "./components/tax"
  export default {
    name: "PageService",
    data(){
      return {
        activeName:'carrier',

      }
    },
    components:{
      termsOfCarriage,
      compensation,
      embargo,
      pack,
      warehouse,
      tax
    },
    mounted() {
      if(this.$route.query.to) {
        this.$nextTick(() => {
          var refname = this.$route.query.to
          console.log(refname)
          this.$refs[refname].click()
        })
      }

    }
  }
</script>

<style lang="scss" scoped>
  .tab-bar {
    position: relative;
    width: 100%;
    margin: 0 auto;
    height: 100px;
    text-align: center;
  }

  .tab-bar-inner {
    display: inline-block;
  }
  .tab-bar-inner div {
    display: inline-block;
    /*width: 198px;*/
    height: 70px;
    background: rgb(194, 46, 44);
    color: #fff;
    line-height: 70px;
    text-align: center;
    margin-right: 15px;
    cursor: pointer;
    padding: 0 53px;
  }
  .tab-bar-inner div:nth-last-child(1){
    margin-right: 0;
  }

  .tab-bar-inner div.active {
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3);
  }
  .container{
    text-align: center;
  }
</style>
<style>
  .pageService .wrapper{
    width: 1000px;
    display: inline-block;
  }
  .pageService .title{
    font-size: 24px;
    color: rgb(51,51,51);
    line-height: 60px;
    border-bottom: 2px solid rgb(191,191,191);
    font-weight: bolder;
  }
</style>



// WEBPACK FOOTER //
// src/view/PageService/PageService.vue